function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9004,
  cy: 21.223,
  r: 20.75,
  fill: "#A66FFE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.173 13.6508C21.448 13.6508 22.4525 12.6463 22.4525 11.3714C22.4525 10.0964 21.448 9.09192 20.173 9.09192C18.8981 9.09192 17.8936 10.0964 17.8936 11.3714C17.8936 12.6463 18.8981 13.6508 20.173 13.6508ZM20.173 9.86461C21.023 9.86461 21.6798 10.5214 21.6798 11.3714C21.6798 12.2213 21.023 12.8781 20.173 12.8781C19.323 12.8781 18.6663 12.2213 18.6663 11.3714C18.6663 10.5214 19.323 9.86461 20.173 9.86461Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6773 28.0617L26.432 21.6484L26.2775 21.262C26.2389 21.1075 26.0843 20.9916 25.9298 20.9916H22.2595V20.0643H25.0798C25.3116 20.0643 25.4662 19.9098 25.4662 19.678V17.1281C25.4662 16.8963 25.3116 16.7417 25.0798 16.7417H22.2595V15.0032C22.2595 14.7714 22.1049 14.6168 21.8731 14.6168H18.4733C18.2415 14.6168 18.0869 14.7714 18.0869 15.0032V23.9278C18.0869 24.1596 18.2415 24.3142 18.4733 24.3142H23.6117L26.3161 29.723C26.3934 29.8776 26.5093 29.9548 26.6638 29.9548C26.7025 29.9548 26.7797 29.9548 26.8184 29.9162L29.4842 28.6026C29.5614 28.564 29.6387 28.4867 29.6773 28.3708C29.716 28.2549 29.716 28.139 29.6773 28.0617ZM26.857 29.0276L24.1912 23.7346C24.1139 23.6187 23.998 23.5028 23.8435 23.5028H18.8596V15.3509H21.4868V17.0894C21.4868 17.3213 21.6413 17.4758 21.8731 17.4758H24.6935V19.253H21.8731C21.6413 19.253 21.4868 19.4075 21.4868 19.6393V21.3393C21.4868 21.5711 21.6413 21.7256 21.8731 21.7256H25.6593L25.7366 21.8802V21.9188L28.8274 28.0231L26.857 29.0276Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3025 28.7184C21.9889 30.032 20.289 30.7274 18.4731 30.7274C14.6869 30.7274 11.6348 27.6752 11.6348 23.889C11.6348 20.8755 13.6438 18.2097 16.5028 17.3597C16.6959 17.2825 16.8118 17.0893 16.7732 16.8961C16.6959 16.703 16.5028 16.5871 16.3096 16.6257C13.1029 17.5916 10.9007 20.5664 10.9007 23.9277C10.8621 28.1002 14.2619 31.5001 18.4731 31.5001C20.4821 31.5001 22.4139 30.6887 23.8434 29.2593C23.9979 29.1047 23.9979 28.8729 23.8434 28.7184C23.6888 28.5638 23.457 28.5638 23.3025 28.7184Z",
  fill: "white"
});

var SvgLtd = function SvgLtd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLtd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ltd.4ab8d905.svg";
export { ForwardRef as ReactComponent };